import "./Home.css";
import HeroSection from "../components/HeroSection";
import AboutUs from "../components/AboutUs";
import PastClients from "../components/PastClients";
import Testimonials from "../components/Testimonials";
import Staff  from "../components/staff"; 
import Contact from "./Contact";
import GetInTouch from "../components/GetInTouch";


const Home = () => {
  return (
    <div className="home">
      <HeroSection />
      <AboutUs />
      <PastClients />
      <Testimonials />
      <Staff />
      <GetInTouch />
      <Contact  />
    </div>
  );
};

export default Home;
